export function socialProfileUrl(platform?: string, username?: string) {
  const handle = username?.trim().replace(/^@+/, "");
  if (!handle) return undefined;
  const normalized = platform?.toLowerCase();
  if (normalized === "instagram") return `https://instagram.com/${handle}`;
  if (normalized === "youtube") return `https://youtube.com/@${handle}`;
  return undefined;
}
